import apiClient, { ApiResponse } from '@/api/api-client'

export type CreateCheckoutLinkPayload = {
  path: string
  pkgId: string
  refreshToken: string
  accessToken: string
  idToken: string
}

export type CreateCheckoutLinkResponse = {
  url: string
  expiresAt: string
}

export type RedeemCheckoutSessionResponse = {
  accessToken: string
  idToken: string
  refreshToken: string
  path: string
  pkgId: string
}

export async function createCheckoutLink(payload: CreateCheckoutLinkPayload): Promise<CreateCheckoutLinkResponse> {
  const res = await apiClient.post<ApiResponse<CreateCheckoutLinkResponse>>('/auth/checkout-link', payload)
  return res.data.data
}

export async function redeemCheckoutSession(token: string): Promise<RedeemCheckoutSessionResponse> {
  const res = await apiClient.post<ApiResponse<RedeemCheckoutSessionResponse>>('/auth/checkout-session', { token })
  return res.data.data
}
